import { useState, FormEvent } from 'react';

interface LoginFormProps {
  onLogin: (login: string, password: string) => Promise<boolean>;
}

export default function LoginForm({ onLogin }: LoginFormProps) {
  const [loginVal, setLoginVal] = useState('');
  const [passwordVal, setPasswordVal] = useState('');
  const [showPass, setShowPass] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const ok = await onLogin(loginVal, passwordVal);
      if (!ok) {
        setError('Неверный логин или пароль. Попробуйте ещё раз.');
      }
    } catch {
      setError('Ошибка подключения к серверу. Попробуйте позже.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="w-full space-y-5">
      <div>
        <label className="block text-sm font-medium text-foreground-700 mb-2">Логин</label>
        <div className="relative">
          <span className="absolute left-4 top-1/2 -translate-y-1/2 text-foreground-500 w-5 h-5 flex items-center justify-center">
            <i className="ri-user-3-line text-lg" />
          </span>
          <input
            type="text"
            autoComplete="username"
            value={loginVal}
            onChange={(e) => setLoginVal(e.target.value)}
            placeholder="Введите логин"
            className="w-full bg-surface-2 border border-surface-5 rounded-xl pl-11 pr-4 py-3.5 text-sm text-foreground-900 placeholder-foreground-500 focus:outline-none focus:border-primary-500 transition-colors"
          />
        </div>
      </div>

      <div>
        <label className="block text-sm font-medium text-foreground-700 mb-2">Пароль</label>
        <div className="relative">
          <span className="absolute left-4 top-1/2 -translate-y-1/2 text-foreground-500 w-5 h-5 flex items-center justify-center">
            <i className="ri-lock-line text-lg" />
          </span>
          <input
            type={showPass ? 'text' : 'password'}
            autoComplete="current-password"
            value={passwordVal}
            onChange={(e) => setPasswordVal(e.target.value)}
            placeholder="Введите пароль"
            className="w-full bg-surface-2 border border-surface-5 rounded-xl pl-11 pr-11 py-3.5 text-sm text-foreground-900 placeholder-foreground-500 focus:outline-none focus:border-primary-500 transition-colors"
          />
          <button
            type="button"
            onClick={() => setShowPass((p) => !p)}
            className="absolute right-4 top-1/2 -translate-y-1/2 text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer w-5 h-5 flex items-center justify-center"
          >
            <i className={showPass ? 'ri-eye-off-line' : 'ri-eye-line'} />
          </button>
        </div>
      </div>

      {error && (
        <div className="flex items-center gap-2.5 bg-red-500/10 border border-red-500/30 rounded-xl px-4 py-3">
          <span className="w-5 h-5 flex items-center justify-center text-red-400 flex-shrink-0">
            <i className="ri-error-warning-line text-lg" />
          </span>
          <span className="text-sm text-red-400">{error}</span>
        </div>
      )}

      <button
        type="submit"
        disabled={loading || !loginVal || !passwordVal}
        className="w-full bg-primary-600 hover:bg-primary-500 disabled:opacity-50 disabled:cursor-not-allowed text-on-primary font-semibold rounded-xl py-3.5 text-sm transition-all duration-200 cursor-pointer whitespace-nowrap"
      >
        {loading ? (
          <span className="flex items-center justify-center gap-2">
            <i className="ri-loader-4-line animate-spin" /> Входим...
          </span>
        ) : (
          'Войти в систему'
        )}
      </button>
    </form>
  );
}
